import WarningAltFilled20 from '@carbon/icons-react/es/warning--alt--filled/20';
import styled from 'styled-components';

const Wrapper = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WarningIcon = ({
  color = 'var(--red-50)',
}: {
  color?: string;
}): React.JSX.Element => {
  return (
    <Wrapper color={color}>
      <WarningAltFilled20 color={color} />
    </Wrapper>
  );
};
